import { normalize } from 'normalizr'
import { category } from '../adapters/categorySchema'
import { organization } from '../adapters/organizationSchema'
import { rate } from '../adapters/rateSchema'
import * as ActionTypes from './actionTypes'

// categories actions
export const expedia_fetchCategoriesSuccess = data => ({
    type: ActionTypes.EXPEDIA_CATEGORIES_FETCH_SUCCESS,
    ...data
})

export const expedia_fetchCategoriesFailure = error => ({
    type: ActionTypes.EXPEDIA_CATEGORIES_FETCH_FAILURE,
    error
})

export const expedia_saveCategoriesSuccess = data => ({
    type: ActionTypes.EXPEDIA_CATEGORIES_SAVE_SUCCESS,
    data: normalize(data, category)
})

export const expedia_saveCategoriesFailure = error => ({
    type: ActionTypes.EXPEDIA_CATEGORIES_SAVE_FAILURE,
    error
})

export const expedia_deleteCategorySuccess = id => ({
    type: ActionTypes.EXPEDIA_CATEGORIES_DELETE_SUCCESS,
    data: id
})

export const expedia_deleteCategoryFailure = error => ({
    type: ActionTypes.EXPEDIA_CATEGORIES_DELETE_FAILURE,
    error
})

export const expedia_importCategoriesSuccess = data => ({
    type: ActionTypes.EXPEDIA_CATEGORIES_IMPORT_SUCCESS,
    ...data
})

export const expedia_importCategoriesFailure = error => ({
    type: ActionTypes.EXPEDIA_CATEGORIES_IMPORT_FAILURE,
    error
})

// organizations actions
export const expedia_fetchOrganizationsSuccess = data => ({
    type: ActionTypes.EXPEDIA_ORGANIZATIONS_FETCH_SUCCESS,
    ...data
})

export const expedia_fetchOrganizationsFailure = error => ({
    type: ActionTypes.EXPEDIA_ORGANIZATIONS_FETCH_FAILURE,
    error
})

export const expedia_saveOrganizationsSuccess = data => ({
    type: ActionTypes.EXPEDIA_ORGANIZATIONS_SAVE_SUCCESS,
    data: normalize(data, organization)
})

export const expedia_updateOrganizationsFailure = error => ({
    type: ActionTypes.EXPEDIA_ORGANIZATIONS_UPDATE_FAILURE,
    error
})

export const expedia_updateOrganizationsSuccess = data => ({
    type: ActionTypes.EXPEDIA_ORGANIZATIONS_UPDATE_SUCCESS,
    data: normalize(data, organization)
})

export const expedia_deleteOrganizationSuccess = id => ({
    type: ActionTypes.EXPEDIA_ORGANIZATIONS_DELETE_SUCCESS,
    data: id
})

export const expedia_deleteOrganizationFailure = error => ({
    type: ActionTypes.EXPEDIA_ORGANIZATIONS_DELETE_FAILURE,
    error
})

export const expedia_saveOrganizationsFailure = error => ({
    type: ActionTypes.EXPEDIA_ORGANIZATIONS_SAVE_FAILURE,
    error
})

// currentOrganization actions
export const expedia_changeCurrentOrganization = id => ({
    type: ActionTypes.EXPEDIA_CURRENT_ORGANIZATION_CHANGE,
    data: id
})

// rates actions
export const expedia_fetchRatesSuccess = data => ({
    type: ActionTypes.EXPEDIA_RATES_FETCH_SUCCESS,
    ...data
})

export const expedia_fetchRatesFailure = error => ({
    type: ActionTypes.EXPEDIA_RATES_FETCH_FAILURE,
    error
})

export const expedia_saveRatesSuccess = data => ({
    type: ActionTypes.EXPEDIA_RATES_SAVE_SUCCESS,
    data: normalize(data, rate)
})

export const expedia_saveRatesFailure = error => ({
    type: ActionTypes.EXPEDIA_RATES_SAVE_FAILURE,
    error
})

export const expedia_deleteRateSuccess = id => ({
    type: ActionTypes.EXPEDIA_RATES_DELETE_SUCCESS,
    data: id
})

export const expedia_deleteRateFailure = error => ({
    type: ActionTypes.EXPEDIA_RATES_DELETE_FAILURE,
    error
})

export const expedia_importRatesSuccess = data => ({
    type: ActionTypes.EXPEDIA_RATES_IMPORT_SUCCESS,
    ...data
})

export const expedia_importRatesFailure = error => ({
    type: ActionTypes.EXPEDIA_RATES_IMPORT_FAILURE,
    error
})

// sync actions
export const expedia_pushYearPricesRequest = () => ({
    type: ActionTypes.EXPEDIA_PUSH_YEAR_PRICES_REQUEST
})
export const expedia_pushYearPricesSuccess = () => ({
    type: ActionTypes.EXPEDIA_PUSH_YEAR_PRICES_SUCCESS
})
export const expedia_pushYearPricesFailure = () => ({
    type: ActionTypes.EXPEDIA_PUSH_YEAR_PRICES_FAILURE
})

export const expedia_pushYearRestrictionsRequest = () => ({
    type: ActionTypes.EXPEDIA_PUSH_YEAR_RESTRICTIONS_REQUEST
})
export const expedia_pushYearRestrictionsSuccess = () => ({
    type: ActionTypes.EXPEDIA_PUSH_YEAR_RESTRICTIONS_SUCCESS
})
export const expedia_pushYearRestrictionsFailure = () => ({
    type: ActionTypes.EXPEDIA_PUSH_YEAR_RESTRICTIONS_FAILURE
})

export const expedia_pushYearAvailabilityRequest = () => ({
    type: ActionTypes.EXPEDIA_PUSH_YEAR_AVAILABILITY_REQUEST
})
export const expedia_pushYearAvailabilitySuccess = () => ({
    type: ActionTypes.EXPEDIA_PUSH_YEAR_AVAILABILITY_SUCCESS
})
export const expedia_pushYearAvailabilityFailure = () => ({
    type: ActionTypes.EXPEDIA_PUSH_YEAR_AVAILABILITY_FAILURE
})

export const expedia_inventoryAvailabilityRequest = () => ({
    type: ActionTypes.EXPEDIA_INVENTORY_AVAILABILITY_REQUEST
})
export const expedia_inventoryAvailabilitySuccess = () => ({
    type: ActionTypes.EXPEDIA_INVENTORY_AVAILABILITY_SUCCESS
})
export const expedia_inventoryAvailabilityFailure = () => ({
    type: ActionTypes.EXPEDIA_INVENTORY_AVAILABILITY_FAILURE
})

export const expedia_inventoryOrderRequest = () => ({
    type: ActionTypes.EXPEDIA_INVENTORY_ORDER_REQUEST
})
export const expedia_inventoryOrderSuccess = () => ({
    type: ActionTypes.EXPEDIA_INVENTORY_ORDER_SUCCESS
})
export const expedia_inventoryOrderFailure = () => ({
    type: ActionTypes.EXPEDIA_INVENTORY_ORDER_FAILURE
})

// easyms
export const expedia_fetchEasymsCategoriesSuccess = data => ({
    type: ActionTypes.EXPEDIA_EASYMS_CATEGORIES_FETCH_SUCCESS,
    payload: { ...data }
})
export const expedia_fetchEasymsCategoriesFailure = error => ({
    type: ActionTypes.EXPEDIA_EASYMS_CATEGORIES_FETCH_FAILURE,
    payload: { error }
})
export const expedia_fetchEasymsRatesSuccess = data => ({
    type: ActionTypes.EXPEDIA_EASYMS_RATES_FETCH_SUCCESS,
    payload: { ...data }
})
export const expedia_fetchEasymsRatesFailure = error => ({
    type: ActionTypes.EXPEDIA_EASYMS_RATES_FETCH_FAILURE,
    payload: { error }
})


// WEBPACK FOOTER //
// ./src/actions/expediaActions.js